// "Me avisa quando chegar" — Onda Catalogo Fase 3.
// Aparece na pagina publica do produto quando ele esta "Sob consulta" (sem
// estoque). O cliente deixa o WhatsApp e o pedido cai numa lista interna que
// o admin consulta na tela Catalogo Digital.
import { useState } from 'react';
import { BellRing, Check } from 'lucide-react';

export function AviseMeQuandoChegar({ produtoId }: { produtoId: number }) {
  const [aberto, setAberto] = useState(false);
  const [nome, setNome] = useState('');
  const [whatsapp, setWhatsapp] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState<string | null>(null);
  const [pronto, setPronto] = useState(false);

  async function enviar() {
    const digitos = whatsapp.replace(/\D/g, '');
    if (digitos.length < 10 || digitos.length > 13) {
      setErro('Informe um WhatsApp valido com DDD.');
      return;
    }
    setEnviando(true);
    setErro(null);
    try {
      const r = await fetch(`/api/public/catalogo/${produtoId}/avise-me`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ whatsapp: digitos, nome: nome.trim() || undefined }),
      });
      if (!r.ok) {
        const d = await r.json().catch(() => ({}));
        setErro(d?.erro || 'Nao foi possivel enviar agora. Tente novamente.');
        return;
      }
      setPronto(true);
    } catch {
      setErro('Erro de conexao. Tente novamente.');
    } finally {
      setEnviando(false);
    }
  }

  if (pronto) {
    return (
      <div
        className="rounded-lg border px-4 py-3 flex items-start gap-2 text-sm"
        style={{ backgroundColor: '#ecfdf5', borderColor: '#a7f3d0', color: '#065f46' }}
      >
        <Check size={18} className="mt-0.5 flex-shrink-0" />
        <span>
          <strong>Pronto!</strong> Assim que o produto chegar, a gente te chama no WhatsApp.
        </span>
      </div>
    );
  }

  const campoStyle = {
    width: '100%',
    padding: '10px 12px',
    borderRadius: 8,
    border: '1px solid #d4d4d4',
    backgroundColor: '#fff',
    color: '#111',
    fontSize: '16px', // 16px evita o zoom automatico do iOS
    textTransform: 'none' as const,
  };

  return (
    <div
      className="rounded-lg border px-4 py-3"
      style={{ backgroundColor: '#fff', borderColor: '#e5e5e5' }}
    >
      {!aberto ? (
        <button
          type="button"
          onClick={() => setAberto(true)}
          className="w-full inline-flex items-center justify-center gap-2 py-2.5 rounded-lg font-semibold text-sm"
          style={{ backgroundColor: '#b45309', color: '#fff' }}
        >
          <BellRing size={18} /> Avise-me quando chegar
        </button>
      ) : (
        <div>
          <p className="text-sm font-medium text-gray-800">
            Deixe seu WhatsApp — avisamos assim que o produto voltar:
          </p>
          <div className="mt-2.5 space-y-2">
            <input
              className="no-upper"
              style={campoStyle}
              placeholder="Seu nome (opcional)"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              maxLength={120}
            />
            <input
              className="no-upper"
              style={campoStyle}
              placeholder="WhatsApp com DDD — ex: (64) 99999-9999"
              inputMode="tel"
              value={whatsapp}
              onChange={(e) => setWhatsapp(e.target.value)}
              maxLength={20}
            />
          </div>
          {erro && <p className="mt-2 text-xs" style={{ color: '#dc2626' }}>{erro}</p>}
          <button
            type="button"
            onClick={enviar}
            disabled={enviando}
            className="mt-3 w-full inline-flex items-center justify-center gap-2 py-2.5 rounded-lg font-semibold text-sm disabled:opacity-60"
            style={{ backgroundColor: '#b45309', color: '#fff' }}
          >
            {enviando ? 'Enviando...' : 'Quero ser avisado'}
          </button>
        </div>
      )}
    </div>
  );
}
